import { defineStore } from 'pinia'
import axios from 'axios'
import { useGinnelStore } from '@/stores/ginnels/ginnel'
import { useCollectionsStore } from '@/stores/collections/collections'
import { getResponse, getMeta, getError } from '@/composables/api'
import router from '@/router'

export const useGinnelsStore = defineStore({
   id: 'ginnels',
   state: () => ({
      ginnels: [],
      gotGinnels: false,

      currentPage: 1,
      hasMoreData: true,

      storeGinnel: useGinnelStore(),
      storeCollections: useCollectionsStore(),
   }),
   actions: {
      /**
         * Function: get
         * @description Sends a get requiest to the API
         * to get all ginnels.
      */
      get(payload) {
         if(typeof payload != 'object')
            payload = { collection_id: payload }

         this.gotGinnels = false

			axios.get('ginnels', { params: payload }).then((response) => {
            this.gotGinnels = true
            // If the page is greater than 1, append the data, otherwise replace the data.
            if(payload?.page > 1)
               this.ginnels = this.ginnels.concat(getResponse(response).ginnels)
            else
               this.ginnels = getResponse(response).ginnels

            this.currentPage = getMeta(response)?.current_page
            this.hasMoreData = getMeta(response)?.has_more_data
			})
      },
      /**
         * Function: add
         * @description Sends a post requiest to the API
         * to add a ginnel.
         *
         * @param {Object} formData
      */
      add(formData) {
			axios.post('ginnel', formData).then((response) => {
            let ginnel = getResponse(response)
            this.storeGinnel.ginnel = ginnel
            this.ginnels.unshift(ginnel)
            this.storeCollections.get()

            // Once the ginnel has been added, navigate to it
            router.push({ name: 'collection.ginnel', params: { ginnel_id: ginnel?.ginnel_id, collection_id: ginnel?.collection_id } })
			})
      }
   }
})